import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import QuizresultList from './quizresult-list.component';
import QuizresultCreate from './quizresult-create.component';
import QuizresultView from './quizresult-view.component';
import QuizresultEdit from './quizresult-edit.component';
import QuizresultCopy from './quizresult-copy.component';
import QuizresultDelete from './quizresult-delete.component';

interface Props {
  root?: string;
}

export const QuizresultRoute: React.FunctionComponent<Props> = (props) => {

  return (
    <Switch>           
      <Route path={(props.root||'') + '/quizresult/create'} component={QuizresultCreate} />
      <Route path={`${props.root||''}/quizresult/view`} render={(params) => <QuizresultView {...params} key={params.history.location.key} root={props.root} />} />        
      <Route path={`${props.root||''}/quizresult/edit`} render={(params) => <QuizresultEdit {...params} key={params.history.location.key} root={props.root} />} />        
      <Route path={`${props.root||''}/quizresult/copy`} component={QuizresultCopy} />
      <Route path={`${props.root||''}/quizresult/delete`} render={(params) => <QuizresultDelete {...params} key={params.history.location.key} root={props.root} />} />        
      <Route path={(props.root||'') + '/quizresult'} render={(params) => <QuizresultList {...params} root={props.root} />} /> 
    </Switch>
  );
}
